import { Loading } from '@/components/loading/Loading';
import { FC } from 'react';

import { PageHeader } from './PageHeader';

export const PageLoading: FC = () => {
  return (
    <>
      <PageHeader></PageHeader>
      <div className="flex-1">
        <Loading className="p-10" />
      </div>
    </>
  );
};
